import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import {
  Icon,
  RowView,
  RowView2,
} from "../../../../Component/style/common_style";
import { OrderList } from "../../../../Component/Interface/Order";
import RenderMultiRows2, {
  HeaderRow,
  Row,
} from "../../../../Component/style/orderTable_style2";
import { fontStyles } from "../../../../Component/style/common_font";

interface payDoneDate extends modalProps {
  data: OrderList;
}

const PayDoneModal = ({ visible, handleModal, data }: payDoneDate) => {
  const closeModal = () => {
    handleModal();
  };
  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  return (
    <Container style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox onClick={stopPropagation}>
        <Title>
          입금정보 확인
          <Icon
            src={require("../../../../Image/ic_closeX.png")}
            onClick={closeModal}
          />
        </Title>
        <ContentDiv>
          <SubTitle>주문정보</SubTitle>
          <TableHeader>
            <HeaderRow $width={6}>주문일시</HeaderRow>
            <HeaderRow $width={4}>주문자</HeaderRow>
            <HeaderRow $width={5}>입금자</HeaderRow>
            <HeaderRow $width={5}>택배비</HeaderRow>
            <HeaderRow>총 결제금액</HeaderRow>
          </TableHeader>

          <Table>
            <Row $width={6}>{data.order_dt}</Row>
            <Row $width={4}>{data.order_name}</Row>
            <Row $width={5}>{data.order_nickname}</Row>
            <Row $width={5}>{data.delivery_price}</Row>
            <Row>{data.total_payment}</Row>
          </Table>
          <SubTitle style={{ marginTop: 30 }}>입금정보</SubTitle>
          <TableHeader>
            <HeaderRow $width={6}>입금일시</HeaderRow>
            <HeaderRow $width={15}>입금자명</HeaderRow>
            <HeaderRow $width={15}>입금액</HeaderRow>
          </TableHeader>

          <Table>
            <Row $width={6}>{data.order_dt}</Row>
            <Row $width={15}>{data.order_name}</Row>
            <Row $width={15}>{data.total_payment}</Row>
          </Table>
        </ContentDiv>
      </ModalBox>
    </Container>
  );
};
export default PayDoneModal;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 510px;
  margin: auto 0rem;
  background-color: white;
  color: #2d2d2d;
  border-radius: 8px;
  overflow: hidden;
  padding: 40px 30px;
  div.info {
    color: #8e8e8e;
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
`;

const Title = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const SubTitle = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
`;

const ContentDiv = styled.div`
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: var(--font-Pretendard-Regular);
  flex-direction: column;
  text-align: center;
  color: black;
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.div`
  border-radius: 8px;
  padding: 18px 30px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-Pretendard-Medium);
  cursor: pointer;
`;

const CancelBtn = styled(Btn)`
  margin-right: 5px;
  background-color: #e4e4e4;
  color: #8e8e8e;
`;

const ApplyBtn = styled(Btn)`
  margin-left: 5px;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  color: white;
`;

const TableHeader = styled(RowView2)`
  margin-top: 16px;
  width: 100%;
  height: 2.5rem;
  border-top: 1px solid #8e8e8e;
  border-left: 1px solid #8e8e8e;
  ${fontStyles.Bold}
  background-color: #e5e5e5;
`;

const Table = styled(RowView2)<{ $height?: number }>`
  width: 100%;
  border-right: 1px solid #8e8e8e;
  height: ${(props) =>
    props.$height ? `${props.$height * 2.5}rem` : "2.5rem"};
`;
